import { render, staticRenderFns } from "./subject_list.vue?vue&type=template&id=0cc76c39&scoped=true"
import script from "./subject_list.vue?vue&type=script&lang=ts"
export * from "./subject_list.vue?vue&type=script&lang=ts"
import style0 from "./subject_list.vue?vue&type=style&index=0&id=0cc76c39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc76c39",
  null
  
)

export default component.exports